import chengHeader from './src/chengHeader.vue'

chengHeader.install = function (Vue) {
    Vue.component(chengHeader.name,chengHeader)
}

export default chengHeader